import { ScrollManager } from "@folio-2026/shared"
import { atom, createStore } from "jotai"
import { Pane } from "tweakpane"

// import * as settings from "../settings";
const initialSettings = {
  active: false,
  showOrbitControls: false,
  showScrollManagerInfo: false,
}

export const debugAtom = atom(initialSettings)
export const debugStore = createStore()

/**
 * The Debug class is used to create a debug UI for the experience.
 */
export default class Debug {
  active: boolean
  ui: Pane | undefined
  settings: typeof initialSettings

  constructor() {
    this.active = window.location.hash === "#debug"
    this.settings = { ...debugStore.get(debugAtom) }

    if (this.active) {
      debugStore.set(debugAtom, (prev) => ({
        ...prev,
        active: true,
      }))

      // this.ui = new gui.GUI()
      this.ui = new Pane()

      const settingsFolder = this.ui.addFolder({
        title: "⚙️ Settings",
        expanded: false,
      })

      const showOrbitControls = settingsFolder.addBinding(
        this.settings,
        "showOrbitControls",
      )
      showOrbitControls.on("change", (e) => {
        const val = e.value
        debugStore.set(debugAtom, (prev) => ({
          ...prev,
          showOrbitControls: val,
        }))
      })

      const scrollManagerInfo = settingsFolder.addBinding(
        this.settings,
        "showScrollManagerInfo",
      )
      scrollManagerInfo.on("change", (e) => {
        const val = e.value
        debugStore.set(debugAtom, (prev) => ({
          ...prev,
          showScrollManagerInfo: val,
        }))

        const scrollManager = ScrollManager.getInstance<string>({
          viewportHeight: window.innerHeight,
          debug: this.active,
        })

        if (e.value) {
          scrollManager.showInfo()
        } else {
          scrollManager.removeInfo()
        }
      })
    }
  }
}
